export default __webpack_public_path__ + "static/media/logo3.a53768b0.png";